module.exports = __webpack_public_path__ + "static/media/ImgMBTI_SPTA.b27dcd83.png";